<template>
  <v-row class="no-gutters bg-white pa-2 mb-3">
    <v-col class="col-12">
      <p class="subtitle-2 font-weight-bold mb-1">
        {{ appServiceName }}<span>&nbsp;&#45;&nbsp;</span
        ><span>{{ appIupCode }}&nbsp;</span
        ><span v-if="appIupCode">
          <base-copy-button
            :copiedText="copiedText"
            :valueToCopy="appIupCode"
          ></base-copy-button> </span
        ><span>
          <v-chip
            color="success"
            class="white--text font-weight-bold caption text-uppercase state-chip"
            >{{ $t(`billAppointments.states.${appState}`) }}</v-chip
          >
        </span>
      </p>
    </v-col>
    <v-row class="no-gutters">
      <v-col class="col-6">
        <v-row class="no-gutters">
          <v-col class="col-12"
            ><p class="subtitle-2 font-weight-bold mb-2">
              <span v-if="appScheduleDate"
                >{{ $t("billAppointments.scheduleDate") }}&#58;&nbsp;{{
                  appScheduleDate | date(dateTimeFormat)
                }}</span
              >
              <span v-else class="font-italic text-uppercase">{{
                $t("emptyData")
              }}</span>
            </p></v-col
          >
        </v-row>
        <v-row class="no-gutters">
          <v-col class="col-12"
            ><p class="subtitle-2 font-weight-bold mb-2">
              <span>{{ $t("billAppointments.price") }}&#58;&nbsp;</span>
              <span>{{ servicePriceForFE }}&nbsp;&euro;</span>
            </p>
          </v-col>
        </v-row>
        <v-row class="no-gutters">
          <v-col class="col-12"
            ><p class="subtitle-2 font-weight-bold">
              <span v-if="appMemberFullName"
                >{{ $t("billAppointments.beneficiary") }}&#58;&nbsp;{{
                  appMemberFullName
                }}</span
              >
              <span v-else class="font-italic text-uppercase">{{
                $t("emptyData")
              }}</span>
            </p></v-col
          >
        </v-row>
      </v-col>
      <v-col class="col-6">
        <v-row class="no-gutters" align="start">
          <!-- appointment delivery date -->
          <v-col class="col-auto mr-3">
            <div class="font-weight-bold">
              {{ $t("billAppointments.deliveryDate") }}
            </div>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formattedDeliveryDate"
                  class="input-field small"
                  outlined
                  dense
                  filled
                  v-on="on"
                  readonly
                  hide-details
                  append-icon="fa-solid fa-pencil"
                  @click:append="on.click"
                ></v-text-field>
              </template>
              <v-date-picker
                class="date-picker"
                v-model="appointmentObj.delivery.date"
                :locale="$i18n.locale"
                :min="minAllowedDeliveryDate"
                :max="maxAllowedDeliveryDate"
                :first-day-of-week="1"
                @input="onDeliveryDateSelected"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            v-if="isExemptionGtePrice"
            class="body-1 font-weight-bold pt-2 card-text-color"
          >
            <div>
              {{ $t("appointments.details.doneDialog.warning") }}
            </div>
          </v-col>
          <template v-else>
            <!-- invoice number -->
            <v-col class="col-auto mr-3">
              <div class="font-weight-bold">
                {{ $t("billAppointments.invoiceNumber") }}
              </div>
              <v-text-field
                :rules="[invoiceNumberRule]"
                v-model="appointmentObj.invoice.number"
                class="input-field small"
                outlined
                dense
                filled
                v-mask="['XXXXXXXXXXXXXXXXXXXXXXXX']"
                append-icon="fa-solid fa-pencil"
                :disabled="appointment.invoice.numberDisabled"
              ></v-text-field>
            </v-col>
            <!-- invoice date -->
            <v-col class="col-auto mr-3">
              <div class="font-weight-bold">
                {{ $t("billAppointments.invoiceDate") }}
              </div>
              <v-menu
                v-model="idMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formattedInvoiceDate"
                    class="input-field small"
                    outlined
                    dense
                    filled
                    v-on="on"
                    readonly
                    hide-details
                    append-icon="fa-solid fa-pencil"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  class="date-picker"
                  v-model="appointmentObj.invoice.iDate"
                  :locale="$i18n.locale"
                  :min="minAllowedInvoiceDate"
                  :max="maxAllowedInvoiceDate"
                  :first-day-of-week="1"
                  @input="idMenu = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- invoice total -->
            <v-col class="col-auto mr-3">
              <div class="font-weight-bold">
                {{ $t("billAppointments.invoiceTotal") }}
              </div>
              <v-text-field
                :rules="[equalsPriceTotalRule]"
                class="input-field small money-field"
                placeholder="0,00"
                outlined
                dense
                filled
                @input="onInvoiceTotalSelected"
                append-icon="fa-solid fa-euro-sign"
              ></v-text-field>
            </v-col>
            <!-- <v-col class="col-auto mr-3 mt-6">
              <v-tooltip bottom content-class="portal-tooltip-inverted">
                  <template v-slot:activator="{ on }">
                    <img
                      v-on="on"
                      :src="iconYesterday"
                      alt=""
                      class="date-icon mr-3"
                      @click="setInvoiceDate('-1')"
                      style="cursor: pointer"
                    />
                  </template>
                  <span>{{ $t("billAppointments.iconYesterday") }}</span>
                </v-tooltip>
                <v-tooltip bottom content-class="portal-tooltip-inverted">
                  <template v-slot:activator="{ on }">
                    <img
                      v-on="on"
                      :src="iconToday"
                      alt=""
                      class="date-icon mr-3"
                      @click="setInvoiceDate('0')"
                      style="cursor: pointer"
                    />
                  </template>
                  <span>{{ $t("billAppointments.iconToday") }}</span>
                </v-tooltip>
              <v-tooltip bottom content-class="portal-tooltip-inverted">
                <template v-slot:activator="{ on }">
                  <img
                    v-on="on"
                    :src="iconApp"
                    alt=""
                    class="date-icon mr-3"
                    @click="setInvoiceDate('app')"
                    style="cursor: pointer"
                  />
                </template>
                <span>{{ $t("billAppointments.iconApp") }}</span>
              </v-tooltip>
              <v-tooltip bottom content-class="portal-tooltip-inverted">
                <template v-slot:activator="{ on }">
                  <img
                    v-on="on"
                    :src="iconPerform"
                    alt=""
                    class="date-icon"
                    @click="setInvoiceDate('del')"
                    style="cursor: pointer"
                  />
                </template>
                <span>{{ $t("billAppointments.iconPerform") }}</span>
              </v-tooltip>
            </v-col> -->
          </template>
        </v-row>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import dayjs from "dayjs";
import BaseCopyButton from "../BaseCopyButton";
import NestMoney from "../../NestMoney";

export default {
  components: {
    BaseCopyButton
  },
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      copiedText: this.$t("iupCodeCopied"),
      dateTimeFormat: "DD/MM/YYYY HH:mm",
      menu: false,
      idMenu: false,
      appointmentObj: null,
      iconYesterday: require("@/assets/icons/iconyesterday_pr.png"),
      iconToday: require("@/assets/icons/icontoday_pr.png"),
      iconApp: require("@/assets/icons/iconappointment_pr.png"),
      iconPerform: require("@/assets/icons/iconperform_pr.png"),
      deliveryDateDeviation: 0,
      invoiceDateDeviation: 0
    };
  },
  created() {
    this.appointmentObj = { ...this.appointment };
    this.deliveryDateDeviation = parseInt(
      process.env.VUE_APP_DELIVERY_DATE_DEVIATE_MONTHS
    );
    this.invoiceDateDeviation = parseInt(
      process.env.VUE_APP_INVOICE_DATE_DEVIATE_MONTHS
    );
    this.appointmentObj.invoice.iDate = this.appointmentObj.delivery.date;
  },
  computed: {
    appServiceName() {
      return this.appointmentObj?.serviceName || null;
    },
    appIupCode() {
      if (this.appointmentObj?.iupCode) {
        return this.appointmentObj.iupCode;
      }
      return null;
    },
    appState() {
      if (this.appointmentObj?.state) {
        return this.appointmentObj.state;
      }
      return null;
    },
    appScheduleDate() {
      if (this.appointmentObj?.appointmentScheduleDate) {
        return this.appointmentObj.appointmentScheduleDate;
      }
      return null;
    },
    servicePriceForFE() {
      return NestMoney.formatCurrencyForFE(this.appointmentObj.price);
    },
    priceForOP() {
      return NestMoney.formatCurrencyForOP(this.appointmentObj.price);
    },
    exemptionForOP() {
      return NestMoney.formatCurrencyForOP(this.appointmentObj.exemption);
    },
    isExemptionGtePrice() {
      let exemption = Number.parseFloat(this.exemptionForOP);
      let price = Number.parseFloat(this.priceForOP);
      return exemption >= price;
    },
    appMemberFullName() {
      return `${this.appointmentObj?.memberName} ${this.appointmentObj?.memberSurname} (${this.appointmentObj?.memberCodiceFiscale})`;
    },
    // delivery date
    formattedDeliveryDate() {
      let date = dayjs(this.appointmentObj.delivery.date);
      return date.isValid() ? date.format("DD/MM/YYYY") : "";
    },
    minAllowedDeliveryDate() {
      let appDate = dayjs(this.appointmentObj.appointmentScheduleDate);
      let minDate = appDate.isValid()
        ? appDate.subtract(this.deliveryDateDeviation, "month")
        : dayjs();
      return minDate.format("YYYY-MM-DD");
    },
    maxAllowedDeliveryDate() {
      let appDate = dayjs(this.appointmentObj.appointmentScheduleDate);
      let limitDate = dayjs(appDate).add(this.deliveryDateDeviation, "month");
      let maxDate =
        limitDate.isValid() && limitDate.isBefore(dayjs())
          ? limitDate
          : dayjs();
      return maxDate.format("YYYY-MM-DD");
    },
    // invoice date
    formattedInvoiceDate() {
      let date = dayjs(this.appointmentObj.invoice.iDate);
      return date.isValid() ? date.format("DD/MM/YYYY") : "";
    },
    minAllowedInvoiceDate() {
      let delDate = dayjs(this.appointmentObj.delivery.date);
      let minDate = delDate.isValid()
        ? delDate.subtract(this.invoiceDateDeviation, "month")
        : dayjs();
      return minDate.format("YYYY-MM-DD");
    },
    maxAllowedInvoiceDate() {
      let delDate = dayjs(this.appointmentObj.delivery.date);
      let limitDate = dayjs(delDate).add(this.invoiceDateDeviation, "month");
      let maxDate =
        limitDate.isValid() && limitDate.isBefore(dayjs())
          ? limitDate
          : dayjs();
      return maxDate.format("YYYY-MM-DD");
    }
  },
  methods: {
    onDeliveryDateSelected(val) {
      this.menu = false;
      // invoice date must be in a specific range based on the delivery date;
      // set the invoice date equal to delivery date every time the delivery date changes to
      // recalculate the correct range with the "invoiceDateDeviation" property
      this.appointmentObj.invoice.iDate = val;
    },
    onInvoiceTotalSelected(val) {
      this.appointmentObj.invoice.total = NestMoney.formatCurrencyForBE(val);
    },
    setInvoiceDate(value) {
      let dFormat = "YYYY-MM-DD";
      let invoiceDate = null;
      if (value === "-1") {
        invoiceDate = dayjs().subtract(1, "day").format(dFormat);
      }
      if (value === "0") {
        invoiceDate = dayjs().format(dFormat);
      }
      if (value === "app") {
        if (this.appointmentObj.appointmentScheduleDate) {
          invoiceDate = dayjs(
            this.appointmentObj.appointmentScheduleDate
          ).format(dFormat);
        }
      }
      if (value === "del") {
        if (this.appointmentObj.delivery.date) {
          invoiceDate = dayjs(this.appointmentObj.delivery.date).format(
            dFormat
          );
        }
      }
      if (invoiceDate) {
        // invoice date must be in a specific range based on the delivery date;
        // set the delivery date equal to invoice date every time the invoice date changes to
        // recalculate the correct range with the "invoiceDateDeviation" property
        this.appointmentObj.invoice.iDate = invoiceDate;
        this.appointmentObj.delivery.date = invoiceDate;
        this.appointmentObj.delivery.hour = "12";
        this.appointmentObj.delivery.minutes = "00";
      }
    },
    invoiceNumberValid(v) {
      return !/^[a-zA-Z]+$/.test(v);
    },
    invoiceNumberRule(v) {
      if (!v) return true;
      if (this.invoiceNumberValid(v)) {
        return true;
      } else {
        return this.$t("appointments.details.invoiceNumberError");
      }
    },
    equalsPriceTotal(v) {
      const amount = NestMoney.formatCurrencyAmountForOP(v);
      const priceAmount = NestMoney.formatCurrencyAmountForOP(
        this.servicePriceForFE
      );
      return amount === priceAmount;
    },
    equalsPriceTotalRule(v) {
      if (!v) return true;
      if (this.equalsPriceTotal(v)) {
        return true;
      } else {
        return this.$t("appointments.details.totalError");
      }
    }
  }
};
</script>

<style scoped>
.bg-white {
  background-color: white;
}
.v-text-field >>> .v-input__slot {
  min-height: 20px !important;
}
.v-select >>> .v-select__slot {
  height: 32px !important;
}
.input-field.x-small {
  max-width: 120px;
}
.input-field.small {
  max-width: 140px;
}
.input-field >>> .v-input__append-inner {
  margin-top: 4px !important;
}
.input-field >>> .v-icon.notranslate.fa.fa-solid.fa-pencil.theme--light {
  font-size: 15px !important;
  color: var(--primary) !important;
}
.money-field >>> input {
  text-align: right;
}
.v-select.input-field {
  max-width: 70px;
}
.v-select >>> .v-select__selection--comma {
  width: 100%;
  text-align: center;
}
.date-picker >>> .v-date-picker-title__date,
.date-picker >>> .v-date-picker-header__value button {
  text-transform: capitalize;
}
.date-icon {
  width: 20px !important;
  height: 20px !important;
}
.state-chip {
  height: auto;
  min-height: 24px;
  margin-bottom: 3px;
}
.state-chip >>> .v-chip__content {
  height: auto !important;
}
</style>
